// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import NoResultsBannerWithFilterButton from '../NoResultsBannerWithFilterButton/NoResultsBannerWithFilterButton';

export const NoResultsMsg = () => (
    <div className="NoResults">
        <FormattedMessage
            id="noresults"
            defaultMessage="There are no results which match your criteria. Try refining your search parameters."
        />
    </div>
);

type Props = {numFilters?: number};

const NoResults = ({numFilters = 0}: Props) => {
    if (numFilters > 0) {
        return <NoResultsBannerWithFilterButton />;
    }
    return <NoResultsMsg />;
};
NoResults.displayName = 'NoResults';

export default NoResults;
